module.exports = __webpack_public_path__ + "static/media/withBorder.3c197426.svg";